const Errors = {
    DefaultError: "Erro com a sua solicitação, entre em contato com o suporte.",
    EmptySignUpUsername: "E-mail está vazio.",
    EmptySignInUsername: "E-mail está vazio.",
    UsernameExistsException: "E-mail já cadastrado.",
    UserNotFoundException: "E-mail não cadastrado.",
    NotAuthorizedException: "E-mail ou senha incorreto.",
    CodeMismatchException: "Código inválido.",
    InvalidPasswordException: "Senha deve conter ao menos 8 dígitos.",
    LimitExceededException: "Limite de solicitações atingida, tente novamente mais tarde.",
    EmptyConfirmSignUpUsername: "Usuário não identificado.",
    ExpiredCodeException: "Código expirado. Solicite um novo código e tente novamente.",
    SignInException: "Não foi possível validar o código de acesso.",
    EmptyResetPasswordUsername: "E-mail não preenchido para recuperar senha.",
}

export default Errors;